import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Loader2 } from 'lucide-react';

export const LeadRunNotice = ({ api, workspaceId, collapsed, isDarkMode }) => {
  const [run, setRun] = useState(null);
  useEffect(() => {
    if (!workspaceId) return;
    let active = true;
    const load = async () => {
      try { const r = await api.get(`/api/workspaces/${workspaceId}/lead-runs`); if (active) setRun(r.data.runs || []); } catch { /* transient */ }
    };
    load(); const timer = setInterval(load, 12000);
    window.addEventListener('voxinity:lead-scan-started', load);
    return () => { active = false; clearInterval(timer); window.removeEventListener('voxinity:lead-scan-started', load); };
  }, [api, workspaceId]);
  const live = (run || []).filter(r => ['queued', 'running', 'authorizing'].includes(r.status));
  if (!live.length || collapsed) return null;
  const sum = k => live.reduce((t, r) => t + (r.counts?.[k] || 0), 0);
  const money = k => live.reduce((t, r) => t + (r[k] || 0), 0);
  const total = live.reduce((t, r) => t + (r.found || r.count || 0), 0);
  return <Link to={`/workspace/${workspaceId}/leads`} data-testid="lead-package-sidebar-notice" className={`block mx-3 mb-3 p-3 rounded-md border ${isDarkMode ? 'border-emerald-400/20 bg-emerald-400/5 text-emerald-200' : 'border-emerald-200 bg-emerald-50 text-emerald-800'}`}>
    <span className="flex items-center gap-2 text-xs font-semibold"><Loader2 size={13} className="animate-spin"/>Deep Analysis · {live.length > 1 ? `${live.length} runs` : live[0].status}</span>
    <span className="block text-[11px] mt-1" data-testid="lead-package-sidebar-totals">{sum('ready')} of {total} ready · {sum('failed')} failed<br/>${money('charged').toFixed(2)} charged · ${money('held').toFixed(2)} held</span>
  </Link>;
};